import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  Grid,
  Input,
  makeStyles,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  TextField,
  Theme,
  Typography
} from '@material-ui/core';
import { CreateOutlined, ExpandLessOutlined, ExpandMore, HighlightOff, WarningRounded } from '@material-ui/icons';
import { YELLOW_MOBILE } from 'constants/colors';
import useRouter from 'hooks/useRouter';
import React, { FC, useEffect, useState } from 'react';

interface Props {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  handleOpen: () => void;
}
const useStyles = makeStyles((theme: Theme) => ({
  titleContainer: {
    fontWeight: 500,
    fontSize: '1.2rem'
  },
  button: {
    borderRadius: '15px',
    padding: '7px 0'
  }
}));
const ModalMergeColly: FC<Props> = ({ open, setOpen, handleOpen }) => {
  const classes = useStyles();
  return (
    <Dialog open={open} style={{ maxHeight: 80 + 'vh', marginTop: '60px' }} scroll='paper' fullWidth>
      <DialogTitle>
        <Grid item container direction='column' alignItems='center' xs={12}>
          <WarningRounded style={{ color: YELLOW_MOBILE, fontSize: '3.5rem' }} />
          <Typography className={classes.titleContainer}>Konfirmasi</Typography>
        </Grid>
      </DialogTitle>
      <DialogContent>
        <Grid xs={12}>
          <Typography align='center'>Apakah kamu ingin menggabungkan dengan koli kamu di orderan sebelumnya?</Typography>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Grid xs={12} container justify='center'>
          <Grid xs={11} container direction='column' style={{ gap: '0.6rem' }}>
            <Button size='small' fullWidth className={classes.button} color='primary' onClick={handleOpen}>
              Iya
            </Button>
            <Button size='small' fullWidth variant='text' color='primary' onClick={() => setOpen(false)}>
              Tidak
            </Button>
          </Grid>
        </Grid>
      </DialogActions>
    </Dialog>
  );
};

export default ModalMergeColly;
